import { createSlice } from "@reduxjs/toolkit";
import {
  getTrainersService,
  getTrainerByIdService,
} from "../services/trainers_service";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  trainersList: [],
  metaTrainers: null,
  trainerInfo: null,
};

const slice = createSlice({
  name: "clients",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Using builder callback notation
    builder
      .addCase(getTrainersService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.trainersList = action.payload?.data?.data;
        state.metaTrainers = action.payload.data.meta.meta;
      })
      .addCase(getTrainersService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getTrainersService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getTrainerByIdService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.trainerInfo = action.payload?.data?.data;
      })
      .addCase(getTrainerByIdService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getTrainerByIdService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const { } = slice.actions;
